import { Box } from '@arpeggi/ui'
import { useContext } from 'react'
import { ArpCoverArt } from '../../../../../features/details-page/components'
import { ModalComponents } from '../../../../components/core/Modal'
import { useAuth } from '../../../../hooks/useAuth'
import { MintDetailsForm } from '../MintDetailsForm'
import { RegisterModalContext } from './RegisterSongModal'

export const PublishPage = () => {
  const { user } = useAuth()
  const {
    state: { mintDetails, remixOfSamplePack },
    setTitle,
    setKey,
    setGenres,
    setBpm,
    setColor,
    setCustomWalletAddress
  } = useContext(RegisterModalContext)

  const handleTitleChange = (value?: string) => setTitle(value)
  const handleKeyChange = (value?: number) => setKey(value)
  const handleAddGenre = (value?: string) => setGenres([...mintDetails.genres.value, value])
  const handleRemoveGenre = (value?: string) =>
    setGenres(mintDetails.genres.value.filter((x) => x !== value))
  const handleBpmChange = (value?: number | string) => {
    const parsed = Number(value)
    if (!isNaN(parsed)) {
      setBpm(parsed)
    } else {
      setBpm(60)
    }
  }
  const handleColorChange = (value: string) => setColor(value)

  return (
    <Box>
      <ModalComponents.HeaderContainer>
        <ModalComponents.Title>Enter song details and cover art.</ModalComponents.Title>
        <ModalComponents.Subtitle>
          These details will help listeners discover your song.
        </ModalComponents.Subtitle>
      </ModalComponents.HeaderContainer>
      <ModalComponents.Container css={{ marginBottom: '$24' }}>
        <Box
          css={{
            display: 'flex',
            gap: '64px',
            flexDirection: 'column',
            '@tablet': {
              flexDirection: 'row'
            }
          }}
        >
          <MintDetailsForm
            css={{ flexGrow: 1 }}
            formControls={{
              title: {
                value: mintDetails.title.value,
                handleChange: handleTitleChange,
                error: mintDetails.title.error?.message
              },
              genres: {
                value: mintDetails.genres.value,
                handleAdd: handleAddGenre,
                handleRemove: handleRemoveGenre,
                error: mintDetails.genres.error?.message
              },
              key: {
                value: mintDetails.key.value,
                handleChange: handleKeyChange,
                error: mintDetails.key.error?.message
              },
              bpm: {
                value: mintDetails.bpm.value,
                handleChange: handleBpmChange,
                error: mintDetails.bpm.error?.message
              },
              color: mintDetails.color
                ? {
                    value: mintDetails.color.value,
                    handleChange: handleColorChange,
                    error: mintDetails.color.error?.message
                  }
                : undefined,
              customWalletAddress:
                user?.type === 'admin'
                  ? {
                      value: mintDetails.customWalletAddress.value,
                      handleChange: setCustomWalletAddress
                    }
                  : undefined
            }}
          />
          {remixOfSamplePack && (
            <ArpCoverArt
              css={{ '@tablet': { height: '400px', width: '400px' } }}
              coverImageUrl={remixOfSamplePack.coverImage.url}
            />
          )}
        </Box>
      </ModalComponents.Container>
    </Box>
  )
}
